<template>
    <a-config-provider :locale="arcoLocale">
    <div class="container-box">
        <div class="container-box-top">
            <div class="_head">
                <h1>{{ $t('assets.options_account') }}</h1>
                <div class="button-group">
                    <a-button type="primary" class="button" @click="$emit('topup')">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                             xmlns="http://www.w3.org/2000/svg" class="">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M6 3C6 2.44772 6.44772 2 7 2H9C9.55229 2 10 2.44772 10 3V6H11.0073C11.864 6 12.3241 7.00701 11.7632 7.65465L8.75593 11.1271C8.35716 11.5876 7.64284 11.5876 7.24407 11.1271L4.23682 7.65465C3.67594 7.00701 4.136 6 4.99275 6H6V3ZM4 12C3.44772 12 3 12.4477 3 13C3 13.5523 3.44772 14 4 14H12C12.5523 14 13 13.5523 13 13C13 12.4477 12.5523 12 12 12H4Z"
                                  fill="var(--content-white)">
                            </path>
                        </svg>
                        {{ $t('assets.deposit') }}
                    </a-button>
                </div>
            </div>
            <div class="asset-all">
                <div class="_t">
                    <span>{{ $t('assets.total') }}</span>
                    <div @click="visual = !visual">
                        <icon-eye-invisible v-if="visual" class="color-gray" size="16"/>
                        <icon-eye v-else class="color-gray" size="16"/>
                    </div>
                </div>
                <p class="price">
                    {{ visual ? '********' : (total ? $util.thousandSeparator(total) : '0.00000000') }} USDT
                </p>
                <p class="convert">
                    ≈ {{ symbol }} {{ visual ? '********' : $util.formatFiat(total, symbol_rate, 2) }}
                </p>
            </div>
        </div>
        <!--总览-->
        <div class="content-main-bottom flex align-center jus-bet">
            <div class="btm-left flex flex-column align-start">
                <div class="flex align-center jus-bet btm-left-head">
                    <div class="flex align-center">
                        <span class="font-20 font-bold color-black mr-10">{{ $t('assets.fund_list') }}</span>
                        <a-checkbox value="1" @change="checkboxChange">
                            <span class="font-12 color-gray">{{ $t('assets.hide_zero_assets') }}</span>
                        </a-checkbox>
                    </div>
                    <div>
                        <a-input class="search" v-model="search" :placeholder="$t('assets.search_currency')">
                            <template #prefix>
                                <icon-search/>
                            </template>
                        </a-input>
                    </div>
                </div>
                <!--        -->
                <div class="list">
                    <div>
                        <div class="tab">
                            <span>{{ $t('assets.coin') }}</span>
                            <span>{{ $t('assets.total') }}</span>
                            <span>{{ $t('assets.available') }}</span>
                            <span>{{ $t('assets.frozen') }}</span>
                            <span>{{ $t('assets.asset_conversion_usdt') }}</span>
                            <span>{{ $t('assets.operation') }}</span>
                        </div>
                        <div>
                            <div class="cell flex align-center jus-bet"
                                 v-for="(item,idx) in list"
                                 :key="idx">
                                <div class="cell-item">
                                    <div class="flex align-center">
                                        <img class="coin-icon" :src="item.icon">
                                        <span class="coin-text">{{ item.symbol }}</span>
                                    </div>
                                </div>
                                <div class="cell-item">
                                    <span>{{ formatNumber(item.future_balance) }}</span>
                                </div>
                                <div class="cell-item">
                                    <span>{{ formatNumber(parseFloat(item.future_balance) - parseFloat(item.lock_future)) }}</span>
                                </div>
                                <div class="cell-item">
                                    <span>{{ formatNumber(item.lock_future) }}</span>
                                </div>
                                <div class="cell-item">
                                    <span>
                                        {{ $util.thousandSeparator(item.future_balance * item.new_price, 2) }}
                                    </span>
                                </div>
                                <div class="cell-item">
                                    <a-button class="button-gray" @click="transfeShow = true">{{ $t('assets.transfer') }}</a-button>
                                </div>
                            </div>
                        </div>
                        <div class="flex align-center jus-end mt-20 pagination">
                            <div class="pagination-container">
                                <span class="total-text">{{ paginationText }}</span>
                                <a-pagination 
                                    :total="pagination.total" 
                                    :show-total="false"
                                    show-jumper 
                                    @change="getList"
                                />
                            </div>
                        </div>
                    </div>
                    <not-date v-if="filteredList.length === 0" :height="500"></not-date>
                </div>
            </div>
            <div class="btm-right">
                <div class="btm-right-box">
                    <div class="_title">
                        <span>{{ $t('assets.asset_distribution') }}</span>
                    </div>
                    <div class="flex align-center">
                        <div>
                            <v-chart ref="chart" :option="chartOption" :autoresize="true" width="250px"
                                     height="250px" style="width: 250px; height: 250px;"></v-chart>
                        </div>
                    </div>
                </div>
                <div class="btm-right-box">
                    <div class="_title">
                        <span>{{ $t('assets.fund_flow') }}</span>
                        <span class="seeall">
                            {{ $t('assets.view_all') }}
                        </span>
                    </div>
                    <a-scrollbar class="_list">
                        <div class="_cell" v-for="(item,index) in logList" :key="'l'+item.id">
                            <div class="_item">
                                <span>{{types[item.type]}}</span>
                                <span>{{formatNumber(item.amount)}} {{item.currency.symbol}}</span>
                            </div>
                            <div class="_item">
                                <span>{{item.created_at}}</span>
                                <span class="color-primary">{{ $t('assets.completed') }}</span>
                            </div>
                        </div>
                    </a-scrollbar>
                    <not-date :height="300"></not-date>
                </div>
            </div>
        </div>
    </div>
    <!--    资金划转-->
    <funds-transfe :visible="transfeShow" @close="transfeShow = false"></funds-transfe>
    </a-config-provider>
</template>
<script>
import notDate from "@/components/notdate/notdate.vue";
import {mapGetters} from "vuex";

import VChart from 'vue-echarts';
import * as echarts from 'echarts/core';
import {
    PieChart
} from 'echarts/charts';
import {
    TooltipComponent,
    LegendComponent,
    TitleComponent
} from 'echarts/components';
import {
    CanvasRenderer
} from 'echarts/renderers';
import fundsTransfe from "@/components/fundsTransfe/fundsTransfe.vue";
import upTrigget from "@/components/topUp/topUp.vue";
import withdrawTrgget from "@/components/withdraw/withdraw.vue";
import userApi from "@/common/api/user";

echarts.use([PieChart, TooltipComponent, LegendComponent, CanvasRenderer, TitleComponent]);

export default {
    components: {withdrawTrgget, upTrigget, fundsTransfe, notDate, VChart},
    props: {
        balance: {
            type: Array,
            default: [],
        },
        total: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            transfeShow: false,
            upShow: false,
            withdrawShow: false,

            visual: false,
            checked: false,
            list: [],
            filteredList: [],
            searchKeyword: '',
            pagination: {
                total: 0,
                pageSize: 7
            },
            chartOption:{
                tooltip: {
                    trigger: 'item',
                    backgroundColor: 'var(--background-secondary)',
                    borderColor: 'var(--border-strength-200)',
                    textStyle: {
                        color: 'var(--content-primary)'
                    }
                },
                legend: {
                    orient: 'horizontal',
                    left: 'center',
                    top:"top",
                    textStyle: {
                        color: 'var(--content-primary)',
                        fontSize: 12
                    }
                },
                series: [
                    {
                        name: '',
                        type: 'pie',
                        label:{
                            show:false
                        },
                        center:['50%','50%'],
                        radius: '50%',
                        data: [
                        ],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.3)'
                            }
                        }
                    }
                ]
            },
            types:[],
            logList:[]
        }
    },
    computed: {
        ...mapGetters(['symbol', 'symbol_rate']),
        
        // ArcoDesign组件的locale配置
        arcoLocale() {
            const currentLang = this.$i18n?.locale || 'en-US';
            if (currentLang === 'en-US') {
                return {
                    locale: 'en-US',
                    datePicker: {
                        view: {
                            month: 'Month',
                            year: 'Year',
                            week: 'Week',
                            day: 'Day'
                        },
                        month: {
                            long: {
                                January: 'January',
                                February: 'February',
                                March: 'March',
                                April: 'April',
                                May: 'May',
                                June: 'June',
                                July: 'July',
                                August: 'August',
                                September: 'September',
                                October: 'October',
                                November: 'November',
                                December: 'December'
                            },
                            short: {
                                January: 'Jan',
                                February: 'Feb',
                                March: 'Mar',
                                April: 'Apr',
                                May: 'May',
                                June: 'Jun',
                                July: 'Jul',
                                August: 'Aug',
                                September: 'Sep',
                                October: 'Oct',
                                November: 'Nov',
                                December: 'Dec'
                            }
                        },
                        week: {
                            long: {
                                self: 'Week',
                                monday: 'Monday',
                                tuesday: 'Tuesday',
                                wednesday: 'Wednesday',
                                thursday: 'Thursday',
                                friday: 'Friday',
                                saturday: 'Saturday',
                                sunday: 'Sunday'
                            },
                            short: {
                                self: 'Week',
                                monday: 'Mon',
                                tuesday: 'Tue',
                                wednesday: 'Wed',
                                thursday: 'Thu',
                                friday: 'Fri',
                                saturday: 'Sat',
                                sunday: 'Sun'
                            }
                        },
                        placeholder: {
                            date: 'Please select date',
                            week: 'Please select week',
                            month: 'Please select month',
                            year: 'Please select year',
                            quarter: 'Please select quarter',
                            time: 'Please select time'
                        },
                        rangePlaceholder: {
                            date: ['Start date', 'End date'],
                            week: ['Start week', 'End week'],
                            month: ['Start month', 'End month'],
                            year: ['Start year', 'End year'],
                            quarter: ['Start quarter', 'End quarter'],
                            time: ['Start time', 'End time']
                        },
                        selectTime: 'Select time',
                        selectDate: 'Select date',
                        today: 'Today',
                        now: 'Now',
                        ok: 'OK'
                    },
                    pagination: {
                        total: 'Total {total} items',
                        goto: 'Go to',
                        page: 'Page',
                        prev: 'Previous',
                        next: 'Next'
                    }
                };
            }
            return {
                locale: 'zh-CN',
                datePicker: {
                    view: {
                        month: '月',
                        year: '年',
                        week: '周',
                        day: '日'
                    },
                    month: {
                        long: {
                            January: '一月',
                            February: '二月',
                            March: '三月',
                            April: '四月',
                            May: '五月',
                            June: '六月',
                            July: '七月',
                            August: '八月',
                            September: '九月',
                            October: '十月',
                            November: '十一月',
                            December: '十二月'
                        },
                        short: {
                            January: '1月',
                            February: '2月',
                            March: '3月',
                            April: '4月',
                            May: '5月',
                            June: '6月',
                            July: '7月',
                            August: '8月',
                            September: '9月',
                            October: '10月',
                            November: '11月',
                            December: '12月'
                        }
                    },
                    week: {
                        long: {
                            self: '周',
                            monday: '星期一',
                            tuesday: '星期二',
                            wednesday: '星期三',
                            thursday: '星期四',
                            friday: '星期五',
                            saturday: '星期六',
                            sunday: '星期日'
                        },
                        short: {
                            self: '周',
                            monday: '一',
                            tuesday: '二',
                            wednesday: '三',
                            thursday: '四',
                            friday: '五',
                            saturday: '六',
                            sunday: '日'
                        }
                    },
                    placeholder: {
                        date: '请选择日期',
                        week: '请选择周',
                        month: '请选择月份',
                        year: '请选择年份',
                        quarter: '请选择季度',
                        time: '请选择时间'
                    },
                    rangePlaceholder: {
                        date: ['开始日期', '结束日期'],
                        week: ['开始周', '结束周'],
                        month: ['开始月份', '结束月份'],
                        year: ['开始年份', '结束年份'],
                        quarter: ['开始季度', '结束季度'],
                        time: ['开始时间', '结束时间']
                    },
                    selectTime: '选择时间',
                    selectDate: '选择日期',
                    today: '今天',
                    now: '此刻',
                    ok: '确定'
                },
                pagination: {
                    total: '共 {total} 条',
                    goto: '前往',
                    page: '页'
                }
            };
        },
        
        // 自定义分页显示文本
        paginationText() {
            const currentLang = this.$i18n?.locale || 'en-US';
            if (currentLang === 'en-US') {
                return `Total ${this.pagination.total} items`;
            }
            return `共 ${this.pagination.total} 条`;
        }
    },
    mounted() {
        this.pagination.total = this.balance.length
        this.getList(1);
        this.filterData();
        this.getFundLogList();
        // 延迟更新图表，确保DOM完全渲染
        this.$nextTick(() => {
            setTimeout(() => {
                this.updateChart();
            }, 100);
        });
    },
    methods: {
        updateChart() {
            // 确保DOM元素存在且已渲染
            this.$nextTick(() => {
                var data = [];
                this.balance.map((item) => {
                    if (item.future_balance > 0) {
                        data.push({
                            value: parseFloat(item.future_balance),
                            name: item.symbol
                        });
                    }
                });
                this.chartOption['series'][0]['data'] = data;
                
                // 强制更新图表
                setTimeout(() => {
                    if (this.$refs.chart) {
                        this.$refs.chart.resize();
                    }
                }, 50);
            });
        },
        getFundLogList(){
            userApi.getCpitalFlow({
                account:4,
                start_at:"",
                end_at:"",
                currency_id:0,
                type:0,
                page:1
            }).then(res=>{
                console.log(res);
                let types = [];
                res.data.types.map((item)=>{
                    types[item.value] = item.label;
                });
                this.types = types;
                this.logList = res.data.list;
            })
        },
        checkboxChange(e) {
            this.checked = e;
            this.filterData();
        },
        handleSearch() {
            this.filterData();
        },
        filterData() {
            let filtered = this.balance;

            // 搜索过滤
            if (this.searchKeyword.trim()) {
                filtered = filtered.filter(item =>
                    item.symbol.toLowerCase().includes(this.searchKeyword.toLowerCase())
                );
            }

            // 隐藏0资产过滤 - 只隐藏期权账户余额为0的资产
            if (this.checked) {
                filtered = filtered.filter(item => parseFloat(item.future_balance || 0) > 0);
            }

            // 按余额从高到低排序
            filtered.sort((a, b) => parseFloat(b.future_balance || 0) - parseFloat(a.future_balance || 0));

            this.filteredList = filtered;
            this.pagination.total = filtered.length;
            this.getList(1); // 重置到第一页
        },
        getList(c) {
            const startIndex = this.pagination.pageSize * (c - 1);
            const endIndex = startIndex + this.pagination.pageSize;
            this.list = this.filteredList.slice(startIndex, endIndex);
        },
        formatNumber(value) {
            if (!value || parseFloat(value) === 0) {
                return '0.00';
            }
            const num = parseFloat(value);
            // 去除末尾的0，但保留至少2位小数
            return num.toFixed(8).replace(/\.?0+$/, '').replace(/^(\d+\.\d{1})$/, '$10');
        },
    }
}
</script>
<style lang="scss" scoped>
@import "./optionsAccount.scss";

.pagination-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.total-text {
    color: var(--color-text-2);
    font-size: 14px;
}
</style>
